import React from "react";
import Section from "./section";

export default function RouteSetEditPage() {
  return <Section />;
}
